<template>
  <div class="economic-production-pavilion">
    <div class="title">
      <span>广东省民营经济生产总值</span>
      <ElementSelect
              :val="year"
              :options="selectList"
              @val="
          (e) => {
            year = e;
          }
        "
      />
    </div>
    <div class="chart-con has-tab">
      <TabList
              :list="tabList"
              :act="tabIndex"
              @clickItem="
          (item, i) => {
            tabIndex = i;
          }
        "
      />
      <div class="pie-bg" v-if="tabIndex"></div>
      <div class="chart-pie">
        <v-chart ref="pie3D-chart" id="pie3D-chart" class="pie3D-chart" v-show="tabIndex" :options="chartOption" />
        <v-chart ref="pie-chart" id="pie-chart" class="pie-chart" v-show="!tabIndex" :options="chartOption" />
        <div :class="['chart-legend', { chart3d: tabIndex }]">
          <div class="legend-list">
            <div class="legend-item" v-for="(item, i) in chartData" :key="i">
              <div class="name">
                <span class="color" :style="{ 'background-color': tabIndex ? colors3D[i] : colors[i] }"></span>
                <el-tooltip effect="dark" placement="top" v-if="item.name && item.name.length > 6">
                  <span>
                    {{ item.name ? item.name : '-' }}
                  </span>
                  <div slot="content">
                    {{ item.name ? item.name : '-' }}
                  </div>
                </el-tooltip>
                <span v-else>
                  {{ item.name ? item.name : '-' }}
                </span>
              </div>
              <span class="num">
                {{ item.value }}
              </span>
              <span class="unit">亿元</span>
            </div>
          </div>
          <div class="pager-box" v-if="!tabIndex">
            <i :class="['el-icon-caret-top', { dis: pager.current <= 1 }]" @click="changePage(false)"></i>
            <div>
              {{ pager.current }}
              <span> / {{ pager.total }} </span>
            </div>
            <i :class="['el-icon-caret-bottom', { dis: pager.current >= pager.total }]" @click="changePage(true)"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery';
  import drawPie from '../chartJs/pie';
  import drawPie3D from '../chartJs/pie3D';
  import TabList from '../../../components/tabList';
  import echarts from 'echarts';
  import ElementSelect from '../../../components/element-select';

  const colors3D = ['#00c9ff', '#0078ff', '#fcf5c2'];
  const colors = [
    '#00c5fa',
    '#0078ff',
    '#fcf5c2',
    '#58ecac',
    '#ff8c60',
    '#a280ff',
    '#ee6566',
    '#fac959',
    '#91cd74',
    '#3aa272',
    '#aae6ff',
  ];
  export default {
    name: 'EconomicProductionPavilion',
    components: { ElementSelect, TabList },
    props: {
      yearP: {
        type: Number,
        default: 2023,
      },
      selectListP: {
        // 列信息
        type: Array,
        default: () => {
          return [];
        },
      },
    },
    data() {
      return {
        colors,
        colors3D,
        year: this.yearP,
        selectList: [],
        tabIndex: 1,
        tabList: [
          {
            key: 0,
            label: '行业',
          },
          {
            key: 1,
            label: '产业',
          },
        ],
        pager: {
          current: 1,
          total: 2,
        },
        legendBox: null,
        chart: null,
        chartOption3D: null,
        chartOption: null,
        chartData: [],
      };
    },
    watch: {
      tabIndex(n) {
        if (!n && this.chart) {
          this.chart.off('click');
          this.chart.off('mouseover');
          this.chart.off('globalout');
        }
        this.chart = null;
        this.chartOption = null;
        this.chartOption3D = null;
        this.$nextTick(() => {
          this.getYear();
        });
      },
      year(n) {
        this.$nextTick(() => {
          this.getData();
        });
      },
      chartData(n) {
        if (this.legendBox) {
          this.pager.total = n?.length ? Math.ceil((n?.length * 20) / this.legendBox.clientHeight) : 0;
        }
      },
      'pager.current'(n) {
        if (n && this.legendBox) {
          let box = this.legendBox;
          let y = box.clientHeight * (n - 1);
          box.style.transform = `translateY(-${y > 0 ? y + 15 : y}px)`;
        }
      },
    },
    methods: {
      changePage(next) {
        let { current, total } = this.pager;
        if (next) {
          this.pager.current = current < total ? current + 1 : current;
        } else {
          this.pager.current = current > 1 ? current - 1 : current;
        }
      },
      getYear() {
        this.$api.screen.getGDPPrivateEconomyYear({caliber: this.tabList[this.tabIndex].label})
                .then((res) => {
                  if (res && res.data && res.data.data) {
                    const yearData = res.data.data.data;
                    this.selectList = [];

                    if (Array.isArray(yearData)) {
                      yearData.forEach(item => {
                        this.selectList.push({
                          value: item,
                          label: String(item)  // 将value转换为字符串作为label
                        });
                      });
                    } else if (yearData && typeof yearData === 'object') {
                      for (let key in yearData) {
                        this.selectList.push({
                          value: yearData[key],
                          label: String(yearData[key])
                        });
                      }
                    }

                    if (this.selectList.length > 0) {
                      this.year = this.selectList[0].value;
                    } else {
                      this.selectList = [{
                        value: 2023,
                        label: '2023'
                      }];
                      this.year = 2023;
                    }
                  } else {
                    this.selectList = [{
                      value: 2023,
                      label: '2023'
                    }];
                    this.year = 2023;
                  }
                })
                .catch((error) => {
                  console.error('获取年份数据失败:', error);
                  this.selectList = [{
                    value: 2023,
                    label: '2023'
                  }];
                  this.year = 2023;
                });
      },
      getData() {
        const chartElement = this.tabIndex
                ? document.getElementById('pie3D-chart')
                : document.getElementById('pie-chart');

        if (!chartElement) {
          console.error('图表元素未找到');
          return;
        }

        this.chart = echarts.init(chartElement);
        this.$api.screen
                .getGDPPrivateEconomy({
                  caliber: this.tabList[this.tabIndex].label,
                  year: this.year,
                })
                .then((res) => {
                  if (res && res.data && res.data.data) {
                    const { data } = res.data;
                    if (data && data.length) {
                      let list = data.map((item) => {
                        return {
                          name: item.quotaName || '-',
                          value: item.total || 0,
                        };
                      });
                      this.chartData = list;
                      this.$nextTick(() => {
                        this.setInterData();
                      });
                    } else {
                      this.chartData = [];
                      this.$nextTick(() => {
                        this.setInterData();
                      });
                    }
                  } else {
                    this.chartData = [];
                    this.$nextTick(() => {
                      this.setInterData();
                    });
                  }
                })
                .catch((error) => {
                  console.error('获取数据失败:', error);
                  this.chartData = [];
                  this.$nextTick(() => {
                    this.setInterData();
                  });
                });
      },
      setInterData() {
        this.$nextTick(() => {
          let refName = this.tabIndex ? 'pie3D-chart' : 'pie-chart';
          if (this.$refs[refName]) {
            this.$refs[refName].clear();
          }

          if (this.tabIndex) {
            this.chartOption = drawPie3D(this.chartData, 0, this.chart);
          } else {
            this.chartOption = drawPie(this.chartData);
          }
        });
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.getYear();
        let box = $('.legend-list');
        if (box && box.length > 0) {
          this.legendBox = box[0];
        }
      });
    },
    beforeDestroy() {
      if (this.chart) {
        this.chart.dispose();
      }
    },
  };
</script>

<style lang="less" scoped>
  .economic-production-pavilion {
    .chart-box();

    /deep/ .tab-list {
      .tab-item {
        min-width: 60px !important;
      }
    }

    .chart-con {
      overflow: inherit;
    }

    .pie-bg {
      width: 331px;
      height: 198px;
      background: url('~img/home/pie-bg.png') no-repeat;
      background-size: 100% 100%;
      position: absolute;
      left: -45px;
      bottom: -5px;
      /*z-index: 2;*/
    }

    .chart-pie {
      display: flex;
    }

    #pie-chart,
    #pie3D-chart {
      width: 245px;
      height: 220px;
      margin-top: -20px;
    }

    .chart-legend {
      width: calc(100% - 245px);
      /*width: 50%;*/
      color: #fff;
      height: 200px;
      padding-right: 10px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      max-height: 160px;
      overflow: hidden;
      //.show-scroll-bg-trans();

      &.chart3d {
        justify-content: center;
        max-height: 200px;

        .legend-item {
          line-height: 30px;
          margin-bottom: 20px;
        }
      }

      .legend-list {
        height: calc(100% - 20px);
        transition: all 0.3s;
      }

      .pager-box {
        position: absolute;
        right: 0;
        bottom: 10px;
        .flex-center();
        padding-right: 10px;
        font-size: 12px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #87e6ff;
        line-height: 38px;

        div {
          letter-spacing: -2px;
          margin: 0 10px;

          span {
            color: rgba(135, 230, 255, 0.3);
          }
        }

        i {
          margin-top: 2px;
          cursor: pointer;

          &.dis {
            color: rgba(135, 230, 255, 0.3);
            cursor: not-allowed;
          }
        }
      }

      .legend-item {
        .flex-center();
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #dcdcdc;
        /*line-height: 20px;*/
        margin-bottom: 10px;

        &:first-child {
          margin-top: 10px;
        }

        .name {
          width: 100px;
          .flex-center();

          span:last-child {
            width: calc(100% - 21px);
            .ellipsis();
          }
        }
      }

      .color {
        width: 15px;
        height: 11px;
        margin-right: 6px;
      }

      .num {
        width: 80px;
        font-size: 20px;
        font-family: Geometr706 BlkCn BT;
        font-weight: 900;
        color: #fff;
        line-height: 30px;
        margin: 0 5px 0 20px;
        text-align: right;
      }

      .unit {
        font-size: 12px;
      }
    }
  }
</style>
